/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
let selectedConfigurationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'configuration_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(selectedConfigurationIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}